import React from "react";
import { useFormContext, SubmitHandler } from "react-hook-form";
import { Text, Button } from "$components";
import { CategoryFormBasicInfo } from "./CategoryFormBasicInfo";
import { CategoryFormParentCategory } from "./CategoryFormParentCategory";
import { useCategoryForm } from "./context/CategoryFormContext";
import useStyles from "./styles";

type Props = {
  onSubmit: (data: any) => Promise<any>;
};

const CategoryFormContent: React.FC<Props> = ({ onSubmit }) => {
  const form = useFormContext();
  const classes = useStyles();
  const {
    category,
    toggleOpenPopin,
    setActiveCategory,
    setSelectedCategory,
    setParentSelectedCategory,
  } = useCategoryForm();

  const onSubmitHandler: SubmitHandler<any> = async (data: any) => {
    await onSubmit(data).then(() => {
      form.setValue("category", "", { shouldValidate: false });
      setSelectedCategory("");
      setParentSelectedCategory("");
      form.setValue("title", "", { shouldValidate: false });
    });
  };

  return (
    <form
      onSubmit={form.handleSubmit(onSubmitHandler)}
      className={classes.form}
    >
      <Text type="h2">{`${
        category ? "Modifier la" : "Créer une"
      } catégorie`}</Text>

      <CategoryFormBasicInfo />
      <CategoryFormParentCategory />

      <div className={classes.footerForm}>
        <Button
          color="secondary"
          onClick={
            category
              ? () => {
                  setActiveCategory(null);
                  toggleOpenPopin(false);
                }
              : () => toggleOpenPopin(false)
          }
        >
          Annuler
        </Button>
        <Button type="submit">
          {`${category ? "Modifier" : "Créer"} la catégorie`}
        </Button>
      </div>
    </form>
  );
};

export default CategoryFormContent;
